import { call, put, takeEvery } from "redux-saga/effects"
import { GET_SPECIFICATION, GET_SPECIFICATION_LIST } from "./actionTypes"
import {
  getSpecificationAPI,
  getSpecificationListAPI,
} from "helpers/specification_helper"

import {
  getSpecificationSuccess,
  getSpecificationError,
  getSpecificationListSuccess,
  getSpecificationListError,
} from "./actions"
import debounce from "debounce-promise"

const debouncegetSpecificationAPI = debounce(getSpecificationAPI, 1000)
const debouncegetSpecificationListAPI = debounce(getSpecificationListAPI, 1000)

function* fetchSpecification(args) {
  let params = args.payload
  yield put(getSpecificationSuccess({ status: "process", data: {} }))
  try {
    let { data } = yield call(debouncegetSpecificationAPI, params)
    yield put(getSpecificationSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getSpecificationError(error?.response))
  }
}

function* fetchSpecificationList() {
  yield put(getSpecificationListSuccess({ status: "process", data: {} }))
  try {
    let { data } = yield call(debouncegetSpecificationListAPI)
    yield put(getSpecificationListSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getSpecificationListError(error?.response))
  }
}

function* fabricTradingSaga() {
  yield takeEvery(GET_SPECIFICATION, fetchSpecification)
  yield takeEvery(GET_SPECIFICATION_LIST, fetchSpecificationList)
}

export default fabricTradingSaga
